import { __decorate, __param, __metadata } from 'tslib';
import { Inject, ɵɵdefineInjectable, ɵɵinject, Injectable, EventEmitter, ElementRef, ChangeDetectorRef, Input, Output, HostBinding, HostListener, Component, ViewEncapsulation, NgModule } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MdlButtonComponent } from '@angular-mdl/core';

import * as ɵngcc0 from '@angular/core';

const _c0 = ["*"];
let MdlPopoverRegistry = class MdlPopoverRegistry {
    constructor(doc) {
        this.doc = doc;
        this.popoverComponents = [];
        this.doc.addEventListener('click', () => {
            this.popoverComponents
                .filter((component) => component.isVisible)
                .forEach((component) => component.hide());
        });
    }
    add(popoverComponent) {
        this.popoverComponents.push(popoverComponent);
    }
    remove(popoverComponent) {
        this.popoverComponents.slice(this.popoverComponents.indexOf(popoverComponent), 1);
    }
    hideAllExcept(popoverComponent) {
        this.popoverComponents.forEach((component) => {
            if (component !== popoverComponent) {
                component.hide();
            }
        });
    }
};
MdlPopoverRegistry.ɵfac = function MdlPopoverRegistry_Factory(t) { return new (t || MdlPopoverRegistry)(ɵngcc0.ɵɵinject(DOCUMENT)); };
MdlPopoverRegistry.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdlPopoverRegistry.ɵprov = ɵɵdefineInjectable({ factory: function MdlPopoverRegistry_Factory() { return new MdlPopoverRegistry(ɵɵinject(DOCUMENT)); }, token: MdlPopoverRegistry, providedIn: "root" });
MdlPopoverRegistry = __decorate([ __param(0, Inject(DOCUMENT)),
    __metadata("design:paramtypes", [Object])
], MdlPopoverRegistry);
const BOTTOM_LEFT = 'bottom-left'; // Below the element, aligned to its left.
const BOTTOM_RIGHT = 'bottom-right'; // Below the element, aligned to its right.
const TOP_LEFT = 'top-left'; // Above the element, aligned to its left.
const TOP_RIGHT = 'top-right'; // Above the element, aligned to its right.
let PopupPositionService = class PopupPositionService {
    updatePosition(forElement, popoverElement, position) {
        const coordinates = this.calculateCoordinates(forElement, popoverElement, position);
        this.applyCoordinates(coordinates, popoverElement.style);
    }
    applyCoordinates(coordinates, elementStyle) {
        if (!coordinates) {
            return;
        }
        elementStyle.right =
            elementStyle.bottom = '';
        elementStyle.left = coordinates.left + 'px';
        elementStyle.top = coordinates.top + 'px';
    }
    calculateCoordinates(forElement, popoverElement, position) {
        if (!forElement || !position) {
            return null;
        }
        switch (position) {
            case BOTTOM_RIGHT:
                return {
                    top: forElement.offsetTop + forElement.offsetHeight,
                    left: forElement.offsetLeft + forElement.offsetWidth - popoverElement.offsetWidth
                };
            case BOTTOM_LEFT:
                return {
                    top: forElement.offsetTop + forElement.offsetHeight,
                    left: forElement.offsetLeft
                };
            case TOP_LEFT:
                return {
                    top: forElement.offsetTop - popoverElement.offsetHeight,
                    left: forElement.offsetLeft
                };
            case TOP_RIGHT:
                return {
                    top: forElement.offsetTop - popoverElement.offsetHeight,
                    left: forElement.offsetLeft + forElement.offsetWidth - popoverElement.offsetWidth
                };
        }
    }
};
PopupPositionService.ɵfac = function PopupPositionService_Factory(t) { return new (t || PopupPositionService)(); };
PopupPositionService.ɵprov = ɵɵdefineInjectable({ factory: function PopupPositionService_Factory() { return new PopupPositionService(); }, token: PopupPositionService, providedIn: "root" });
let MdlPopoverComponent = class MdlPopoverComponent {
    constructor(changeDetectionRef, elementRef, popoverRegistry, popupPositionService) {
        this.changeDetectionRef = changeDetectionRef;
        this.elementRef = elementRef;
        this.popoverRegistry = popoverRegistry;
        this.popupPositionService = popupPositionService;
        // tslint:disable-next-line
        this.hideOnClick = false;
        // tslint:disable-next-line
        this.onShow = new EventEmitter();
        // tslint:disable-next-line
        this.onHide = new EventEmitter();
        this.isMdlPopover = true;
        this.isVisible = false;
        this.popoverRegistry.add(this);
    }
    onClick(event) {
        if (!this.hideOnClick) {
            event.stopPropagation();
        }
    }
    ngOnDestroy() {
        this.popoverRegistry.remove(this);
    }
    toggle(event, forElement = null) {
        if (this.isVisible) {
            this.hide();
        }
        else {
            this.show(event, forElement);
        }
    }
    hide() {
        if (this.isVisible) {
            this.onHide.emit(null);
            this.isVisible = false;
            this.changeDetectionRef.markForCheck();
        }
    }
    show(event, forElement = null) {
        this.hideAllPopovers();
        event.stopPropagation();
        if (!this.isVisible) {
            this.onShow.emit(null);
            this.isVisible = true;
            this.updateDirection(event, forElement);
        }
    }
    hideAllPopovers() {
        this.popoverRegistry.hideAllExcept(this);
    }
    updateDirection(event, forElement) {
        if (forElement && this.position) {
            const popoverElement = this.elementRef.nativeElement;
            const forHtmlElement = this.getHtmlElement(forElement);
            this.popupPositionService.updatePosition(forHtmlElement, popoverElement, this.position);
            this.changeDetectionRef.markForCheck();
            return;
        }
    }
    getHtmlElement(forElement) {
        if (forElement instanceof MdlButtonComponent) {
            const buttonComponent = forElement;
            return buttonComponent.elementRef.nativeElement;
        }
        if (forElement instanceof ElementRef) {
            const elementRef = forElement;
            return elementRef.nativeElement;
        }
        return forElement;
    }
};
MdlPopoverComponent.ɵfac = function MdlPopoverComponent_Factory(t) { return new (t || MdlPopoverComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MdlPopoverRegistry), ɵngcc0.ɵɵdirectiveInject(PopupPositionService)); };
MdlPopoverComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MdlPopoverComponent, selectors: [["mdl-popover"]], hostVars: 4, hostBindings: function MdlPopoverComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MdlPopoverComponent_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdl-popover", ctx.isMdlPopover)("is-visible", ctx.isVisible);
    } }, inputs: { hideOnClick: ["hide-on-click", "hideOnClick"], position: ["mdl-popover-position", "position"] }, outputs: { onShow: "onShow", onHide: "onHide" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function MdlPopoverComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
MdlPopoverComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: MdlPopoverRegistry },
    { type: PopupPositionService }
];
__decorate([
    Input('hide-on-click'),
    __metadata("design:type", Object)
], MdlPopoverComponent.prototype, "hideOnClick", void 0);
__decorate([
    Input('mdl-popover-position'),
    __metadata("design:type", String)
], MdlPopoverComponent.prototype, "position", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], MdlPopoverComponent.prototype, "onShow", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], MdlPopoverComponent.prototype, "onHide", void 0);
__decorate([
    HostBinding('class.mdl-popover'),
    __metadata("design:type", Object)
], MdlPopoverComponent.prototype, "isMdlPopover", void 0);
__decorate([
    HostBinding('class.is-visible'),
    __metadata("design:type", Object)
], MdlPopoverComponent.prototype, "isVisible", void 0);
__decorate([
    HostListener('click', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Event]),
    __metadata("design:returntype", void 0)
], MdlPopoverComponent.prototype, "onClick", null);
MdlPopoverComponent = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef,
        ElementRef,
        MdlPopoverRegistry,
        PopupPositionService])
], MdlPopoverComponent);

var MdlPopoverModule_1;
let MdlPopoverModule = MdlPopoverModule_1 = class MdlPopoverModule {
    static forRoot() {
        return {
            ngModule: MdlPopoverModule_1,
            providers: []
        };
    }
};
MdlPopoverModule.ɵfac = function MdlPopoverModule_Factory(t) { return new (t || MdlPopoverModule)(); };
MdlPopoverModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MdlPopoverModule });
MdlPopoverModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [MdlPopoverRegistry, PopupPositionService], imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MdlPopoverRegistry, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopupPositionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MdlPopoverComponent, [{
        type: Component,
        args: [{
                selector: 'mdl-popover',
                template: "<ng-content></ng-content>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: MdlPopoverRegistry }, { type: PopupPositionService }]; }, { hideOnClick: [{
            type: Input,
            args: ['hide-on-click']
        }], onShow: [{
            type: Output
        }], onHide: [{
            type: Output
        }], isMdlPopover: [{
            type: HostBinding,
            args: ['class.mdl-popover']
        }], isVisible: [{
            type: HostBinding,
            args: ['class.is-visible']
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], position: [{
            type: Input,
            args: ['mdl-popover-position']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MdlPopoverModule, [{
        type: NgModule,
        args: [{
                imports: [],
                exports: [MdlPopoverComponent],
                declarations: [MdlPopoverComponent],
                providers: [MdlPopoverRegistry, PopupPositionService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MdlPopoverModule, { declarations: [MdlPopoverComponent], exports: [MdlPopoverComponent] }); })();

/*
 * Public API Surface of popover
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MdlPopoverComponent, MdlPopoverModule, MdlPopoverRegistry, PopupPositionService };

